import { render, staticRenderFns } from "./BoardCreate.vue?vue&type=template&id=7c787407&scoped=true"
import script from "./BoardCreate.vue?vue&type=script&lang=js"
export * from "./BoardCreate.vue?vue&type=script&lang=js"
import style0 from "./BoardCreate.vue?vue&type=style&index=0&id=7c787407&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c787407",
  null
  
)

export default component.exports